import clsx, { ClassValue } from "clsx";
import { FC } from "react";

import { IAuditLogMetadata } from "@ryde/shared";

import { FramerTooltip } from "../tooltips/framer-tooltip";
import { AuditLogMetadataLabelsStyled } from "./audit-log-metadata-labels.styled";
import { AuditLogTraceIdBadge } from "./audit-log-trace-id-badge";
import { MetadataTooltipContent } from "./metadata-tooltip-content";

interface IAuditLogMetadataLabelsProps {
  metadataText: string;
  metadataClassNames?: ClassValue;
  metadata?: IAuditLogMetadata | null;
  metadataBadgeClassName: string;
  className?: string;
}

export const AuditLogMetadataLabels: FC<IAuditLogMetadataLabelsProps> = ({
  metadataText,
  metadataClassNames,
  metadata,
  metadataBadgeClassName,
  className,
}) => {
  const traceId = metadata?.traceId?.trim() || undefined;

  if (!metadataText && !traceId) {
    return null;
  }

  return (
    <AuditLogMetadataLabelsStyled
      className={clsx("audit-log-metadata-labels", className)}
    >
      {metadataText && (
        <FramerTooltip content={<MetadataTooltipContent metadata={metadata} />}>
          <span className={clsx(metadataBadgeClassName, metadataClassNames)}>
            {metadataText}
          </span>
        </FramerTooltip>
      )}
      {traceId && <AuditLogTraceIdBadge traceId={traceId} />}
    </AuditLogMetadataLabelsStyled>
  );
};
